import { NzMessageService } from 'ng-zorro-antd/message';
import { Component, Input, OnInit } from '@angular/core';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-cell-quantity',
  templateUrl: './cell-quantity.component.html',
  styleUrls: ['./cell-quantity.component.less'],
})
export class CellQuantityComponent extends Cell {
  binLocationDrawer = false;
  binLocationDrawerOpened = false;
  binLocationData = [];

  constructor(
    public layoutService: LayoutService,
    private messageService: NzMessageService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }

  openBinLocationDialog() {
    this.binLocationDrawer = true;
    this.binLocationDrawerOpened = true;
    let queryId = 2742;
    console.log('ss');
    if (this.dataset[this.row].ManBtchNum === 'Y') {
      queryId = 2743;
    }

    this.layoutService
      .executeQuery(queryId, {
        WhsCode: this.dataset[this.row].WhsCode,
        ItemCode: this.dataset[this.row].ItemCode,
        UoMEntry: this.dataset[this.row].UomEntry,
        BinAbs : ''
      })
      .subscribe((e: any[]) => {
        const binLocationDataFromDB = e;
        for (const bin of binLocationDataFromDB) {
          if (this.dataset[this.row].ManBtchNum === 'Y') {
            const existingBin = this.binLocationData.find(
              (b) =>
                b.BinCode === bin.BinCode && b.DistNumber === bin.DistNumber
            );

            if (existingBin != null && existingBin !== undefined) {
              bin.SelectedQuantity = existingBin.SelectedQuantity;
            }
          } else {
            const existingBin = this.binLocationData.find(
              (b) => b.BinCode === bin.BinCode
            );

            if (existingBin != null && existingBin !== undefined) {
              bin.SelectedQuantity = existingBin.SelectedQuantity;
            }
          }
        }

        this.binLocationData = binLocationDataFromDB;
      });
  }

  binQuantitySelected(bin) {
    if (bin.SelectedQuantity > bin.OnHandQty) {
      this.messageService.error(
        this.layoutService.translate(
          "Quantity can't exceed the available quantity."
        )
      );
    }

    this.dataset[this.row][this.colData.Name + '_BinData'] = JSON.stringify(
      this.binLocationData.filter(
        (b) => b.SelectedQuantity !== undefined && b.SelectedQuantity > 0
      )
    );
  }
}
